export class TNPSReportingNotice {
    constructor(score, text, helpful, dismissed, displayed, error) {
        this.type = "tnpsReporting";
        this.score = score;
        this.text = text;
        this.helpful = helpful;
        this.dismissed = dismissed;
        this.displayed = displayed;
        this.error = error;
    }
}
